import chapter from './chapter';
import findShortcode from './find-shortcode';

import type { ShortcodeProps } from '../interface';

export default (data: ShortcodeProps) => {
  const html = chapter(data);

  return findShortcode(html);
};
